<template>
  <div id="app" class="">
  <!-- 
    <img src="./assets/logo.png">
  -->
    <my-header/>
    <sidebar/>

    <transition name="fade" mode="out-in" 
        @before-enter="beforeEnter"
        @enter="enter" 
        @after-enter="afterLeave"
        @enter-cancelled="enterCancelled"

        @before-leave="beforeLeave"
        @leave="leave"
        @after-leave="afterLeave"
        @leave-cancelled="leaveCancelled"
        
        >
        <router-view/>
    </transition>

    <my-footer/>

    <!-- bg loading -->
    <loading v-show="showLoad"></loading>
    
  </div>
</template>

<script>
import myHeader from './components/header/header'
import myFooter from './components/footer/footer'
import sidebar from './components/sidebar/sidebar'
import loading from './components/loading/loading'
export default {
  name: 'App',
  data(){
    return{
      showLoad:true
    }
  },
  components:{
    myHeader,
    myFooter,
    sidebar,
    loading
  },
  methods:{
    beforeEnter(){console.log("过度效果开始1");this.showLoad = true;},
    enter(){
      console.log("过度效果开始2");      
        // this.showLoad = true;
    },
    afterLeave(){console.log("过度效果开始3")},
    enterCancelled(){console.log("过度效果开始4")},

    beforeLeave(){console.log("过度效果结束5")},
    leave(){
      console.log("过度效果结束6");
      this.showLoad = true;
    },
    afterLeave(){console.log("过度效果结束7");this.showLoad = false},
    leaveCancelled(){console.log("过度效果结束8")},
  }
}
</script>

<style >
#app {
  /*
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  */
}
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }


</style>



// WEBPACK FOOTER //
// src/App.vue